import { Extension } from '@tiptap/core';
const HintableText = Extension.create({
    name: "hintabletext",
    addGlobalAttributes() {
        return [
            {
                // Extend the following extensions
                types: [
                    'heading',
                    'paragraph',
                ],
                // … with those attributes
                attributes: {
                    hint: {
                        default: '',
                        renderHTML: attributes => ({
                            'data-hint': attributes.hint
                        }),
                        parseHTML: element => element.getAttribute('data-hint'),
                    },
                },
            },
        ];
    },
});
export default HintableText;
